import Vue from 'vue';
import Router from 'vue-router';
import Landing from './views/Landing.vue'
import Header from './components/Header.vue'
import Register from './views/Register.vue'
import Search from './views/Search.vue'
import Sell from './views/Sell.vue'
import Profile from './views/Profile.vue'
// import SearchResult from './views/SearchResult.vue'
import ItemDetail from './views/ItemDetail.vue'
import Edit from './views/Edit.vue'
import EditProfile from './views/EditProfile.vue'
import Trade from './views/Trade.vue'
import PurchasedList from './views/PurchasedList'
import SellingList from './views/SellingList'
import Notifications from './views/Notifications.vue'
import LandingAfterLogin from './views/LandingAfterLogin.vue'
import Policy from './views/Policy.vue'
import Guide from './views/Guide.vue'

Vue.use(Router)

export default new Router ({
    mode: "history",
    routes:[{
        path: '/',
        components: {default: Landing, header: Header}
    },
    {
        path: '/landing',
        name: 'landingafterlogin',
        component: LandingAfterLogin
    },
    {
        path: '/register',
        components: {default: Register, header: Header}
    },
    {
        path: '/search',
        name: 'search',
        component: Search
    },
    {
        path: '/sell',
        name:'sell',
        component: Sell
    },
    {
        path: '/profile',
        name:'profile',
        component: Profile
    },
    // {
    //     path: '/searchResult',
    //     name:'searchResult',
    //     component: SearchResult
    // },
    {
        path: '/itemDetail/:id', //MyPage.vueのrouter-linkのv-bind:のidに指定
        name: 'itemDetail',
        component: ItemDetail,
        props: true
    },
    {
        path: '/editItem/:id',
        name:'editItem',
        component: Edit,
        props: true
    },
    {
        path: '/editProfile',
        name: 'editProfile',
        component: EditProfile,
    },
    {
        path: '/trade',
        name: 'trade',
        component: Trade
    },
    {
        path: '/purchasedList',
        name: 'purchasedList',
        component: PurchasedList
    },
    {
        path: '/sellinglist',
        name:'sellinglist',
        component: SellingList
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: Notifications
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/policy',
        name: 'policy',
        component: Policy
    },
    {
        path: '/guide',
        name: 'guide',
        component: Guide
    }


    ]

})